import React from 'react'
import MaskedInputField from '../../formFields/maskedInputField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <MaskedInputField {...fieldProps} />
))
